/**
 * Global OAuth state tracker to prevent flash of intermediate pages during OAuth callback
 */

/**
 * Check if an OAuth callback is currently in progress
 * This checks the URL for OAuth-specific parameters (code + state)
 */
export function isOAuthCallbackInProgress(): boolean {
  if (typeof window === 'undefined') return false;
  
  const url = new URL(window.location.href);
  return url.searchParams.has('code') && url.searchParams.has('state');
}
